import { useContext } from 'react';

import { DataTableComponentsContext } from 'app/components/DataTableComponents/context/DataTableComponentsContext';

export default () => useContext(DataTableComponentsContext);
